import { createEvent, restore, sample } from 'effector'
import { CreateSettingsCountry } from './types'
import { fx, path } from '../../../../libs'
import { toPath } from '../../../../features/router'
import { updateWebsiteBannerGroup } from '../../../ib/adMaterials/banners/edit/model'
import { getSettingCountryList, SettingCountryListMounted } from '../list/model'

export const setCountrySetting = createEvent<CreateSettingsCountry>()

export const submitCreateCountrySetting = createEvent<string[]>()

export const $countrySetting = restore(setCountrySetting, {
  name: '',
})

export const createCountrySetting = fx<string[], void>({
  method: 'POST',
  url: '/deposit_bonus/unavailable_country/bulk',
})

sample({
  clock: submitCreateCountrySetting,
  fn: (countrySetting) => {
    return {
      url: `/deposit_bonus/unavailable_country/bulk`,
      body: countrySetting,
    }
  },
  target: createCountrySetting,
})

sample({
  // @ts-ignore
  clock: [createCountrySetting.doneData],
  target: SettingCountryListMounted,
})
